import type { App } from 'vue'
import { plugin, defaultConfig } from '@formkit/vue'
import {     
  tr,
  en,
  bs,
  fa,
  ar,
  fr,
  nl,
  ru,
  de,
  id,
 } from '@formkit/i18n'

import { rootClasses } from './formkit.theme.mjs'

export function setupFormkit(app: App) {
  app.use(
    plugin,
    defaultConfig({
      config: {
        rootClasses,
      },
      locales: {
        tr,
        en,
        bs,
        fa,
        ar,
        fr,
        nl,
        ru,
        de,
        id,
      },
      locale: localStorage.getItem('locale') || 'en',
    }),
  )
}
